import * as React from "react";

function SvgVimeo({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill="#4B5563"
          fillRule="nonzero"
          d="M22 7.014c-.09 1.95-1.45 4.62-4.08 8.02-2.72 3.56-5.02 5.31-6.92 5.31-1.15 0-2.14-1.08-2.95-3.25-.55-1.96-1.05-3.94-1.61-5.92-.6-2.16-1.24-3.24-1.94-3.24-.14 0-.66.32-1.56.95L2 7.664c1-.87 1.96-1.74 2.92-2.61 1.32-1.14 2.31-1.74 2.96-1.8 1.56-.16 2.52.92 2.88 3.2.39 2.47.66 4 .81 4.6.43 2.04.93 3.04 1.48 3.04.42 0 1.05-.64 1.89-1.97.84-1.32 1.29-2.33 1.35-3.03.12-1.14-.33-1.71-1.35-1.71-.48 0-.97.11-1.48.33.98-3.23 2.86-4.8 5.63-4.71 2.06.06 3.03 1.4 2.91 4.01z"
        />
      </g>
    </svg>
  );
}

export default SvgVimeo;
